import { render, staticRenderFns } from "./taskScoreDetails.vue?vue&type=template&id=8ade13bc&scoped=true&"
import script from "./taskScoreDetails.vue?vue&type=script&lang=js&"
export * from "./taskScoreDetails.vue?vue&type=script&lang=js&"
import style0 from "./taskScoreDetails.vue?vue&type=style&index=0&id=8ade13bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ade13bc",
  null
  
)

component.options.__file = "taskScoreDetails.vue"
export default component.exports